import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  ${({ isWhite }) =>
    isWhite &&
    `
    background-color: white;
    border-color: #e0e0e0;
    
    &:focus {
      border-color: #007bff;
    }
  `}
`;

export default function SimpleSearch({
  placeholder = "Search...",
  isWhite = false,
  setPhrase,
  initialValue = "",
  value,
  onChange
}) {
  const [internalValue, setInternalValue] = useState(initialValue);

  const currentValue = value !== undefined ? value : internalValue;
  const currentOnChange = onChange || ((newValue) => {
    if (value === undefined) {
      setInternalValue(newValue);
    }
    if (setPhrase) setPhrase(newValue);
  });

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    currentOnChange(newValue);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (setPhrase) setPhrase(currentValue);
    }
  };

  return (
    <SearchContainer>
      <SearchInput
        type="text"
        placeholder={placeholder}
        value={currentValue || ""}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        isWhite={isWhite}
      />
    </SearchContainer>
  );
}

SimpleSearch.propTypes = {
  placeholder: PropTypes.string,
  isWhite: PropTypes.bool,
  setPhrase: PropTypes.func,
  initialValue: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};
